import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';
const SERVER_BASE = process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ============ Auth ============
export const authAPI = {
  getUser: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  logout: () => api.get('/auth/logout'),
  getGoogleLoginUrl: () => `${SERVER_BASE}/api/auth/google`,
};

// ============ Products ============
export const productsAPI = {
  getAll: () => api.get('/products'),
  getOne: (id) => api.get(`/products/${id}`),
};

// ============ Orders ============
export const ordersAPI = {
  getWindowStatus: () => api.get('/orders/window-status'),
  create: (data) => api.post('/orders', data),
  getMyOrders: () => api.get('/orders/my-orders'),
  getOne: (id) => api.get(`/orders/${id}`),
  getInvoiceUrl: (id) => `${SERVER_BASE}/api/orders/${id}/invoice`,
  downloadInvoice: (id) => api.get(`/orders/${id}/invoice`, { responseType: 'blob' }),
};

// ============ Payments ============
export const paymentsAPI = {
  createOrder: (data) => api.post('/payments/create-order', data),
  verify: (data) => api.post('/payments/verify', data),
  getKey: () => api.get('/payments/key'),
};

// ============ Settings ============
export const settingsAPI = {
  getPublic: () => api.get('/settings/public'),
};

// ============ Admin ============
export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getOrders: (params) => api.get('/admin/orders', { params }),
  getOrder: (id) => api.get(`/admin/orders/${id}`),
  updateOrderStatus: (id, data) => api.put(`/admin/orders/${id}/status`, data),
  updateOrderPayment: (id, data) => api.put(`/admin/orders/${id}/payment`, data),
  sendMessageToUser: (id, data) => api.post(`/admin/orders/${id}/message`, data),
  getProducts: () => api.get('/admin/products'),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  getSettings: () => api.get('/settings'),
  updateSettings: (data) => api.put('/settings', data),
};

// ============ Contact ============
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

export default api;
